
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passes/[pageType]",
      function () {
        return require("private-next-pages/passes/[pageType].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passes/[pageType]"])
      });
    }
  